/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserSignatureApiModel } from './user-signature';

export interface UserExternalFormApiModel {
  /**
   * Form filled date (optional, for filled forms only, readonly)
   */
  created?: string;
  /**
   * External Form Id (readonly)
   */
  external_form_id?: string | null;
  /**
   * Empty form file URL
   */
  file?: string | null;
  /**
   * Form data object
   */
  form_data?: object;
  /**
   * User Form Id (optional, readonly)
   */
  id?: string | null;
  signature?: UserSignatureApiModel;
  /**
   * Form signed by user (optional, for filled forms only, readonly)
   */
  signed?: boolean | null;
  /**
   * Form title
   */
  title?: string | null;
  /**
   * Form type
   */
  type?: UserExternalFormApiModelTypeEnum | null;
  /**
   * User data object
   */
  user_data?: object;
  /**
   * User Id (optional, readonly)
   */
  user_id?: string | null;
}
export enum UserExternalFormApiModelTypeEnum {
  Tax = 'tax'
}
